'use client';
import React, { useState } from 'react';
import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';

type FeedTab = 'for-you' | 'following' | 'trending' | 'ask-vet';

const mockPosts = [
{
  id: 'post-001',
  author: 'Maria Santos',
  handle: '@mariasantos',
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_19d49f311-1766940465931.png",
  avatarAlt: 'Filipino woman with short dark hair smiling',
  time: '2h ago',
  content: 'Mochi just had her 4-month booster shots today! She was so brave at the clinic 🐱💉 Dr. Reyes at Petville Vet in Makati was amazing as always. Highly recommend! #FurBabies #CatMom',
  images: [
  {
    src: "https://img.rocket.new/generatedImages/rocket_gen_img_158d6c964-1772132922903.png",
    alt: 'Gray British shorthair cat sitting on vet examination table'
  }],

  likes: 124,
  comments: 18,
  shares: 7,
  isVet: false,
  group: null,
  liked: false
},
{
  id: 'post-002',
  author: 'Dr. Ana Reyes, DVM',
  handle: '@drreyes_vet',
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_113950b5a-1772171833259.png",
  avatarAlt: 'Filipino female veterinarian in white coat at clinic',
  time: '4h ago',
  content: '🩺 VET TIP: Did you know that July to September is peak season for tick infestations in Metro Manila due to the rainy season? Make sure your furbabies are on monthly tick prevention. Ask your vet about Nexgard or Bravecto! 🐕',
  images: [],
  likes: 342,
  comments: 56,
  shares: 89,
  isVet: true,
  group: null,
  liked: false,
  tip: 'Tick prevention is especially important during rainy season. Monthly chewables are 97% effective against ticks and fleas.'
},
{
  id: 'post-003',
  author: 'Carlo Reyes',
  handle: '@carloreyes_dogdad',
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1f569cf12-1779456763308.png",
  avatarAlt: 'Filipino man in casual shirt smiling outdoors',
  time: '6h ago',
  content: 'Biscuit\'s first trip to Quezon Memorial Circle! He was so excited seeing other dogs 🐶 The dog park area near Gate 4 is perfect for socialization. See you furparents there every Sunday morning! #BGCPets #GoldenRetriever',
  images: [
  {
    src: "https://images.unsplash.com/photo-1720711075934-07d3b09eeb55",
    alt: 'Golden retriever puppy running on grass in public park'
  },
  {
    src: "https://images.unsplash.com/photo-1566195211228-cc1414e701d7",
    alt: 'Golden retriever dog sitting next to owner in park'
  }],

  likes: 89,
  comments: 23,
  shares: 4,
  isVet: false,
  group: 'QC Dog Owners',
  liked: false
},
{
  id: 'post-004',
  author: 'Ana Villanueva',
  handle: '@anaville_5furbabies',
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_19d49f311-1766940465931.png",
  avatarAlt: 'Filipino woman with long hair and warm smile',
  time: '8h ago',
  content: '🚨 LOST PET ALERT — Pasig City 🚨\nMissing: Oreo, male black & white Shih Tzu, 2 years old. Last seen near Kapitolyo area this morning. He has a PetHub NFC tag. Please scan if found! Reward offered. Contact: 09XX-XXX-XXXX #LostPet #PasigCity',
  images: [
  {
    src: "https://images.unsplash.com/photo-1563272262-c55ad61698a3",
    alt: 'Black and white Shih Tzu dog sitting on floor indoors'
  }],

  likes: 312,
  comments: 67,
  shares: 245,
  isVet: false,
  group: null,
  liked: false,
  isLostPet: true
},
{
  id: 'post-005',
  author: 'Juana dela Cruz',
  handle: '@juanita_catmom',
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1bcfc9a1f-1772089873655.png",
  avatarAlt: 'Filipino woman with glasses and friendly expression',
  time: '10h ago',
  content: 'Finally got Nala\'s PetHub NFC tag in the mail! 📡 Setup was super easy — just tap to register and her profile is live. The tag looks so cute on her collar too. Thank you PetHub PH! 🐱 #PetHubPH #NFCTag',
  images: [
  {
    src: "https://images.unsplash.com/photo-1619114658272-cdade323ab11",
    alt: 'Orange tabby cat wearing collar with NFC tag outdoors'
  }],

  likes: 201,
  comments: 34,
  shares: 12,
  isVet: false,
  group: null,
  liked: false
},
{
  id: 'post-006',
  author: 'PetHub PH',
  handle: '@pethubph_official',
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1b949dce4-1785153217469.png",
  avatarAlt: 'PetHub PH official account logo on blue background',
  time: '1d ago',
  content: '🏆 Achievement Unlocked! Congratulations to our community — 48,000 pets are now registered on PetHub PH! 🎉 Thank you furparents for trusting us with your furbabies\' safety. To celebrate, we\'re giving 20% off all NFC tags this weekend! Use code: PETHUB48K #PetHubPH #Milestone',
  images: [],
  likes: 1247,
  comments: 189,
  shares: 432,
  isVet: false,
  group: null,
  liked: false,
  isOfficial: true
},
{
  id: 'post-007',
  author: 'Roberto Cruz',
  handle: '@bertcruzdad',
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1d9d8fcad-1772089873275.png",
  avatarAlt: 'Filipino man with mustache wearing casual polo shirt',
  time: '1d ago',
  content: 'Pro tip for new furparents: The Pet Academy course on puppy nutrition by Dr. Dela Cruz changed everything for us. Rocket gained 2kg in a month after we switched his diet! 🐕📚 The Premium membership is so worth it. #PetAcademy #PuppyNutrition',
  images: [],
  likes: 67,
  comments: 15,
  shares: 8,
  isVet: false,
  group: 'New Furparents PH',
  liked: false
},
{
  id: 'post-008',
  author: 'Dr. Miguel Santos, DVM',
  handle: '@drmiguel_vet',
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_12ae6253c-1763296841694.png",
  avatarAlt: 'Filipino male veterinarian in scrubs smiling at camera',
  time: '2d ago',
  content: '🩺 REMINDER: Rabies vaccination is required by law in the Philippines. August is National Rabies Awareness Month. Please make sure your dogs are up to date — free vaccination drives are happening in most LGUs this month! Check our Events page for schedules. 🐕💉',
  images: [],
  likes: 892,
  comments: 124,
  shares: 567,
  isVet: true,
  group: null,
  liked: false,
  tip: 'Rabies vaccination is legally required for all dogs in the Philippines. Free LGU vaccination drives are available in most cities.'
}];


const trendingTags = [
{ tag: '#PetHubPH', count: '12.4k posts' },
{ tag: '#FurBabies', count: '8.9k posts' },
{ tag: '#PinoyPets', count: '6.2k posts' },
{ tag: '#LostPet', count: '2.1k posts' },
{ tag: '#RabiesAwareness', count: '1.8k posts' },
{ tag: '#NFCTag', count: '945 posts' }];


const suggestedFurparents = [
{ id: 'sug-001', name: 'Bea Cruz', handle: '@bea_furparent', pets: 'Cats & Dogs', avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1bcfc9a1f-1772089873655.png", avatarAlt: 'Filipino woman with curly hair smiling' },
{ id: 'sug-002', name: 'Dr. Liza Gomez', handle: '@dr_lizavet', pets: 'Vet · BGC', avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_113950b5a-1772171833259.png", avatarAlt: 'Filipino female veterinarian in clinic wearing stethoscope' },
{ id: 'sug-003', name: 'Paolo Mendoza', handle: '@paolopets', pets: 'Breeder · QC', avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1b671ab1f-1763292989842.png", avatarAlt: 'Filipino man with dark hair in casual setting' }];


const groups = [
{ id: 'grp-001', name: 'BGC Dog Owners', emoji: '🐕', members: '2.4k' },
{ id: 'grp-002', name: 'Pinoy Cat Lovers', emoji: '🐱', members: '5.1k' },
{ id: 'grp-003', name: 'BACH Rescue Network', emoji: '🏠', members: '1.8k' }];


export default function CommunityFeedShell() {
  const [activeTab, setActiveTab] = useState<FeedTab>('for-you');
  const [posts, setPosts] = useState(mockPosts);
  const [composerText, setComposerText] = useState('');
  const [followedIds, setFollowedIds] = useState<Set<string>>(new Set());

  const toggleLike = (postId: string) => {
    setPosts((prev) =>
    prev.map((p) =>
    p.id === postId ?
    { ...p, liked: !p.liked, likes: p.liked ? p.likes - 1 : p.likes + 1 } :
    p
    )
    );
  };

  const toggleFollow = (id: string) => {
    setFollowedIds((prev) => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  };

  const feedTabs: {id: FeedTab;label: string;}[] = [
  { id: 'for-you', label: 'For You' },
  { id: 'following', label: 'Following' },
  { id: 'trending', label: 'Trending' },
  { id: 'ask-vet', label: 'Ask the Vet' }];


  const displayPosts = activeTab === 'ask-vet' ?
  posts.filter((p) => p.isVet) :
  activeTab === 'trending' ?
  [...posts].sort((a, b) => b.likes - a.likes) :
  posts;

  return (
    <div className="min-h-screen bg-[#F6F7F4]">
      <div className="max-w-screen-2xl mx-auto px-4 lg:px-8 py-6">
        <div className="grid grid-cols-1 lg:grid-cols-[250px_1fr_300px] gap-5">
          {/* Left rail */}
          <aside className="hidden lg:flex flex-col gap-4">
            {/* Feed tabs */}
            <div className="bg-white rounded-xl border border-border/60 shadow-card p-3">
              <h3 className="eyebrow text-muted-foreground px-3 mb-2">Feeds</h3>
              {feedTabs.map((tab) =>
              <button
                key={`feed-tab-${tab.id}`}
                onClick={() => setActiveTab(tab.id)}
                className={`w-full text-left px-3 py-2.5 rounded-lg text-sm font-semibold transition-colors flex items-center gap-2 ${
                activeTab === tab.id ?
                'bg-primary-tint text-primary' : 'text-body-text hover:bg-muted'}`
                }>
                
                  {tab.id === 'for-you' && <Icon name="HomeIcon" size={16} />}
                  {tab.id === 'following' && <Icon name="UsersIcon" size={16} />}
                  {tab.id === 'trending' && <Icon name="FireIcon" size={16} />}
                  {tab.id === 'ask-vet' && <Icon name="HeartIcon" size={16} />}
                  {tab.label}
                </button>
              )}
            </div>

            {/* Groups */}
            <div className="bg-white rounded-xl border border-border/60 shadow-card p-4">
              <h3 className="text-sm font-bold text-foreground mb-3">Your Groups</h3>
              {groups.map((g) =>
              <div key={g.id} className="flex items-center gap-3 py-2.5 hover:bg-muted rounded-lg px-2 cursor-pointer transition-colors">
                  <div className="w-9 h-9 rounded-lg bg-primary-tint flex items-center justify-center text-base flex-shrink-0">
                    {g.emoji}
                  </div>
                  <div className="min-w-0">
                    <p className="text-sm font-semibold text-foreground truncate">{g.name}</p>
                    <p className="text-xs text-muted-foreground font-medium">{g.members} members</p>
                  </div>
                </div>
              )}
            </div>

            {/* Gamification card */}
            <div className="bg-navy rounded-xl p-4 flex flex-col gap-3">
              <div className="flex items-center justify-between">
                <div>
                  <p className="eyebrow text-[#B9C3D6]">Your Level</p>
                  <p className="text-lg font-extrabold text-white mt-0.5">Gold Furparent 🥇</p>
                </div>
                <div className="w-10 h-10 rounded-full bg-yellow flex items-center justify-center">
                  <span className="text-navy font-extrabold text-sm">12</span>
                </div>
              </div>
              <div>
                <div className="flex justify-between text-xs mb-1">
                  <span className="text-[#B9C3D6] font-medium">1,240 / 2,000 pts</span>
                  <span className="text-yellow font-bold">62%</span>
                </div>
                <div className="h-2 bg-white/10 rounded-full overflow-hidden">
                  <div className="h-full bg-yellow rounded-full" style={{ width: '62%' }}></div>
                </div>
              </div>
              <p className="text-xs text-[#8A96AB] font-medium">760 pts to reach Platinum 🏆</p>
            </div>
          </aside>

          {/* Center feed */}
          <div className="flex flex-col gap-4 min-w-0">
            {/* Mobile tabs */}
            <div className="lg:hidden flex gap-2 overflow-x-auto scrollbar-hide">
              {feedTabs.map((tab) =>
              <button
                key={`mob-tab-${tab.id}`}
                onClick={() => setActiveTab(tab.id)}
                className={`chip flex-shrink-0 ${activeTab === tab.id ? 'chip-active' : ''}`}>
                
                  {tab.label}
                </button>
              )}
            </div>

            {/* Composer */}
            <div className="bg-white rounded-xl border border-border/60 shadow-card p-4">
              <div className="flex gap-3">
                <div className="w-9 h-9 rounded-full bg-primary-tint flex items-center justify-center flex-shrink-0">
                  <Icon name="UserCircleIcon" size={22} className="text-primary" />
                </div>
                <div className="flex-1">
                  <textarea
                    value={composerText}
                    onChange={(e) => setComposerText(e.target.value)}
                    placeholder="Share a moment with your furbaby... 🐾"
                    rows={2}
                    className="w-full resize-none text-sm text-foreground placeholder:text-muted-foreground font-medium bg-muted rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-primary/20 transition-all"
                    aria-label="Create a post" />
                  
                  <div className="flex items-center justify-between mt-2">
                    <div className="flex gap-1">
                      {[
                      { icon: 'PhotoIcon', label: 'Photo' },
                      { icon: 'VideoCameraIcon', label: 'Video' },
                      { icon: 'TagIcon', label: 'Tag pet' },
                      { icon: 'MapPinIcon', label: 'Location' }].
                      map((action) =>
                      <button
                        key={`compose-${action.label}`}
                        className="flex items-center gap-1 px-2.5 py-1.5 rounded-lg text-xs font-semibold text-muted-foreground hover:bg-muted hover:text-foreground transition-colors"
                        aria-label={action.label}>
                        
                          <Icon name={action.icon as 'PhotoIcon'} size={14} />
                          <span className="hidden sm:inline">{action.label}</span>
                        </button>
                      )}
                    </div>
                    <button
                      disabled={!composerText.trim()}
                      className="btn-primary text-xs px-4 py-2 disabled:opacity-40 disabled:cursor-not-allowed disabled:shadow-none">
                      
                      Post
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* Posts */}
            {displayPosts.map((post) =>
            <div
              key={post.id}
              className={`bg-white rounded-xl border shadow-card overflow-hidden ${
              post.isLostPet ? 'border-brand-red/40' : 'border-border/60'}`
              }>
              
                {/* Lost pet banner */}
                {post.isLostPet &&
              <div className="bg-brand-red px-4 py-2 flex items-center gap-2">
                    <Icon name="ExclamationTriangleIcon" size={16} className="text-white flex-shrink-0" />
                    <span className="text-white text-xs font-extrabold tracking-wide">LOST PET ALERT — Please share & help reunite!</span>
                  </div>
              }

                <div className="p-4">
                  {/* Author row */}
                  <div className="flex items-start justify-between gap-3 mb-3">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-muted relative">
                        <AppImage
                        src={post.avatar}
                        alt={post.avatarAlt}
                        width={40}
                        height={40}
                        className="object-cover w-full h-full" />
                      
                      </div>
                      <div>
                        <div className="flex items-center gap-2 flex-wrap">
                          <span className="text-sm font-bold text-foreground">{post.author}</span>
                          {post.isVet &&
                        <span className="badge-verified text-xs">🩺 Verified Vet</span>
                        }
                          {post.isOfficial &&
                        <span className="bg-primary-tint text-primary text-xs font-bold px-2 py-0.5 rounded-full">✓ Official</span>
                        }
                          {post.group &&
                        <span className="text-xs text-muted-foreground font-medium">in {post.group}</span>
                        }
                        </div>
                        <p className="text-xs text-muted-foreground font-medium">{post.handle} · {post.time}</p>
                      </div>
                    </div>
                    <button className="p-1.5 rounded-lg hover:bg-muted transition-colors" aria-label="Post options">
                      <Icon name="EllipsisHorizontalIcon" size={18} className="text-muted-foreground" />
                    </button>
                  </div>

                  {/* Content */}
                  <p className="text-sm text-body-text leading-relaxed font-medium whitespace-pre-line mb-3">{post.content}</p>

                  {/* Vet tip strip */}
                  {post.isVet && post.tip &&
                <div className="bg-secondary-tint border border-secondary/20 rounded-xl px-4 py-3 mb-3 flex gap-3">
                      <Icon name="LightBulbIcon" size={16} className="text-secondary flex-shrink-0 mt-0.5" />
                      <p className="text-xs text-secondary font-semibold leading-relaxed">{post.tip}</p>
                    </div>
                }

                  {/* Images */}
                  {post.images.length === 1 &&
                <div className="rounded-xl overflow-hidden mb-3 h-[280px] bg-muted">
                      <AppImage
                    src={post.images[0].src}
                    alt={post.images[0].alt}
                    width={600}
                    height={280}
                    className="object-cover w-full h-full" />
                  
                    </div>
                }
                  {post.images.length === 2 &&
                <div className="grid grid-cols-2 gap-2 mb-3">
                      {post.images.map((img, idx) =>
                  <div key={`${post.id}-img-${idx}`} className="rounded-xl overflow-hidden h-[180px] bg-muted">
                          <AppImage
                      src={img.src}
                      alt={img.alt}
                      width={300}
                      height={180}
                      className="object-cover w-full h-full" />
                    
                        </div>
                  )}
                    </div>
                }

                  {/* Action row */}
                  <div className="flex items-center gap-1 pt-2 border-t border-border">
                    <button
                    onClick={() => toggleLike(post.id)}
                    className={`flex items-center gap-1.5 px-3 py-2 rounded-lg text-xs font-semibold transition-colors ${
                    post.liked ?
                    'bg-brand-red-tint text-brand-red' : 'text-muted-foreground hover:bg-brand-red-tint hover:text-brand-red'}`
                    }
                    aria-label={`${post.liked ? 'Unlike' : 'Like'} post`}>
                    
                      <Icon name="HeartIcon" size={15} variant={post.liked ? 'solid' : 'outline'} />
                      <span>{post.likes.toLocaleString()}</span>
                    </button>
                    <button className="flex items-center gap-1.5 px-3 py-2 rounded-lg text-xs font-semibold text-muted-foreground hover:bg-primary-tint hover:text-primary transition-colors">
                      <Icon name="ChatBubbleLeftIcon" size={15} />
                      <span>{post.comments}</span>
                    </button>
                    <button className="flex items-center gap-1.5 px-3 py-2 rounded-lg text-xs font-semibold text-muted-foreground hover:bg-secondary-tint hover:text-secondary transition-colors">
                      <Icon name="ArrowPathRoundedSquareIcon" size={15} />
                      <span>{post.shares}</span>
                    </button>
                    <button className="flex items-center gap-1.5 px-3 py-2 rounded-lg text-xs font-semibold text-muted-foreground hover:bg-accent-tint hover:text-accent-dark transition-colors ml-auto">
                      <Icon name="BookmarkIcon" size={15} />
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Right rail */}
          <aside className="hidden lg:flex flex-col gap-4">
            {/* Trending hashtags */}
            <div className="bg-white rounded-xl border border-border/60 shadow-card p-4">
              <h3 className="text-sm font-bold text-foreground mb-3 flex items-center gap-2">
                <Icon name="FireIcon" size={16} className="text-accent" />
                Trending in PH
              </h3>
              {trendingTags.map((t) =>
              <div
                key={`trend-${t.tag}`}
                className="flex items-center justify-between py-2 px-2 rounded-lg hover:bg-muted cursor-pointer transition-colors">
                
                  <span className="text-sm font-bold text-primary">{t.tag}</span>
                  <span className="text-xs text-muted-foreground font-medium">{t.count}</span>
                </div>
              )}
            </div>

            {/* Suggested furparents */}
            <div className="bg-white rounded-xl border border-border/60 shadow-card p-4">
              <h3 className="text-sm font-bold text-foreground mb-3">Furparents to Follow</h3>
              {suggestedFurparents.map((fp) =>
              <div key={fp.id} className="flex items-center gap-3 py-2.5">
                  <div className="w-9 h-9 rounded-full overflow-hidden flex-shrink-0 bg-muted">
                    <AppImage
                    src={fp.avatar}
                    alt={fp.avatarAlt}
                    width={36}
                    height={36}
                    className="object-cover w-full h-full" />
                  
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-bold text-foreground truncate">{fp.name}</p>
                    <p className="text-xs text-muted-foreground font-medium truncate">{fp.pets}</p>
                  </div>
                  <button
                  onClick={() => toggleFollow(fp.id)}
                  className={`text-xs font-bold px-3 py-1.5 rounded-full transition-colors flex-shrink-0 ${
                  followedIds.has(fp.id) ?
                  'bg-muted text-muted-foreground' :
                  'bg-primary-tint text-primary hover:bg-primary hover:text-white'}`
                  }>
                  
                    {followedIds.has(fp.id) ? 'Following' : 'Follow'}
                  </button>
                </div>
              )}
            </div>

            {/* Event card */}
            <div className="bg-accent-tint border border-accent/20 rounded-xl p-4">
              <div className="flex items-center gap-2 mb-2">
                <div className="w-8 h-8 rounded-lg bg-accent flex items-center justify-center">
                  <Icon name="CalendarIcon" size={16} className="text-white" />
                </div>
                <span className="eyebrow text-accent-dark">Upcoming Event</span>
              </div>
              <h4 className="text-sm font-bold text-foreground mb-1">BACH Adoption Day</h4>
              <p className="text-xs text-body-text font-medium mb-1">Quezon Memorial Circle, Gate 4</p>
              <p className="text-xs text-muted-foreground font-medium mb-3">Aug 10, 2026 · 8AM – 5PM · Free entry</p>
              <button className="btn-secondary text-xs px-4 py-2 w-full justify-center">
                RSVP Now
              </button>
            </div>

            {/* Lost & found quick link */}
            <div className="bg-brand-red-tint border border-brand-red/20 rounded-xl p-4">
              <div className="flex items-center gap-2 mb-2">
                <Icon name="ExclamationTriangleIcon" size={16} className="text-brand-red" />
                <h4 className="text-sm font-bold text-brand-red">Lost & Found</h4>
              </div>
              <p className="text-xs text-body-text font-medium mb-3">
                2 pets reported missing in Metro Manila this week. Help spread the word!
              </p>
              <button className="text-xs font-bold text-brand-red hover:text-brand-red-hover transition-colors flex items-center gap-1">
                View Lost Pets
                <Icon name="ArrowRightIcon" size={12} />
              </button>
            </div>
          </aside>
        </div>
      </div>
    </div>);

}